<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thông tin danh mục slider</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        
                        <b-row>
                            <b-col>
                                <b-form-group label="Tên danh mục slider:"
                                              label-for="name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              :label-class="editing ? 'required' : ''">
                                    <b-form-input type="text" id="name"
                                                  class="col-6"
                                                  v-if="editing"
                                                  aria-describedby="nameFeedback"
                                                  v-model="$v.sliderVideoType.name.$model"
                                                  :state="$v.sliderVideoType.name.$dirty? !$v.sliderVideoType.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="nameFeedback">
                                        Vui lòng nhập tên sliderVideoType
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-6 " v-if="!editing">{{ sliderVideoType.name }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Mã danh mục slider:"
                                              label-for="slug"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              :label-class="editing ? 'required' : ''">
                                    <b-form-input type="text" id="slug"
                                                  class="col-6"
                                                  v-if="editing"
                                                  aria-describedby="slugFeedback"
                                                  v-model="$v.sliderVideoType.slug.$model"
                                                  :state="$v.sliderVideoType.slug.$dirty? !$v.sliderVideoType.slug.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="slugFeedback">
                                        Vui lòng nhập mã sliderVideoType
                                    </b-form-invalid-feedback>
                                    <label class="col-form-label col-6 " v-if="!editing">{{ sliderVideoType.slug }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
              <b-col>
                <b-form-group
                  label="Số thứ tự hiển thị:"
                  label-align="right"
                  label-for="description"
                  :label-cols="4"
                  :horizontal="true"
                >
                  <b-form-input
                    type="number"
                    class="col-6"
                    v-if="editing"
                    v-model="sliderVideoType.orderDisplay"
                  >
                  </b-form-input>
                  <label class="col-form-label col-6" v-if="!editing">{{
                    sliderVideoType.orderDisplay
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>


                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <!--<b-button type="button" variant="primary" @click="edit" v-if="!editing ">Sửa</b-button>-->
                                    <b-button type="button" variant="secondary" @click="back" v-if="!editing">Quay lại</b-button>
                                    <b-button  type="submit" variant="primary" v-if="editing && authorize(['ManageSliderVideoType'])">Ghi lại</b-button>
                                    <b-button type="button" variant="secondary" @click="cancel" v-if="editing">Hủy</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { required, minLength, maxLength, } from 'vuelidate/lib/validators'
    import { authorizationMixin } from '@/shared/mixins'

    export default {
        name: 'tagDetail',
        mixins: [validationMixin, authorizationMixin],
        data() {
            return {
                sliderVideoType: {},
                editing: this.$route.meta.editing,
            }
        },
        computed: {
            tagId() {
                return this.$route.params.tagId;
            },
        },
        validations: {
            sliderVideoType: {
                name: {
                    required,
                    maxLength: maxLength(256)
                },
                slug: {
                    required,
                    maxLength: maxLength(256)
                },
            },
        },
        watch: {
            'sliderVideoType.name'(value) {
                this.sliderVideoType.slug = value.convertslug();
            }
        },
        created() {
            this.loadtagDetail();
        },
        methods: {
            loadtagDetail() {
                var vm = this;
                return this.$services.get(`system/slider-video-types/${this.tagId}`).done(sliderVideoType => {
                    vm.sliderVideoType = sliderVideoType;
                });
            },
            edit() {
                this.editing = true;
            },
            back() {
                this.$router.push({ path: '/system/slider-video-types' });
            },
            cancel() {
                var vm = this;
                this.loadtagDetail().done(() => vm.editing = false);
            },
            save() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var vm = this;
                    this.$services.put(`system/slider-video-types/${this.tagId}`, this.sliderVideoType).done(() => {
                        vm.$toastr.s('Cập nhật sliderVideoType thành công');
                        vm.cancel();
                    });
                }
            },
            checkExistCode(newVal) {
                if (newVal) {
                    //var vm = this;
                    //this.$services.get(`system/existing-unit-types-slug/${newVal}/${this.unitType.id || null}`).done(returnData => {
                    //    if (!returnData) {
                    //        this.slugUnique = "required";
                    //    }
                    //    else {
                    //        this.slugUnique = "";
                    //    }
                    //});
                }
                else {
                    this.slugUnique = "required";
                }
            }
        }
    }
</script>
<style scoped>
</style>
